// Fase 17.3, Plano 10 (D-12): rótulos pt-BR dos avisos de consumo previsto de tinta na liberação da OP.
import type { AvisoConsumoTinta } from '@pieltec/contracts';

export const ROTULO_AVISO_CONSUMO: Readonly<Record<AvisoConsumoTinta, string>> = {
  SEM_AREA: 'Consumo de tinta a definir: falta Área (m²). Preencha em Cadastros → Peças / Produtos → ficha da peça → Dados técnicos.',
  SEM_COR: 'Consumo de tinta a definir: falta Cor (código) ou uma tinta específica. Corrija na ficha da peça, em Dados técnicos ou Tinta da peça.',
  SEM_TINTA_CADASTRADA: 'Consumo de tinta a definir: nenhuma tinta ativa em kg ou litro corresponde à cor e ao tipo da peça. Confira Tipo de tinta, Cor (código), unidade e situação em Cadastros → Materiais.',
  SEM_RENDIMENTO: 'Consumo de tinta a definir: a tinta não tem rendimento (m² por kg ou por litro) e não há rendimento padrão para o tipo dela em Tintas e rendimento.',
  RENDIMENTO_ESTIMADO: 'Rendimento estimado: a tinta não tem rendimento próprio e o consumo usou o rendimento padrão do tipo de tinta. Cadastre o rendimento da tinta em Tintas e rendimento.',
  TINTA_AMBIGUA: 'Consumo de tinta a definir: há mais de uma tinta com a mesma cor e tipo; marque a tinta padrão da cor em Tintas e rendimento.',
  CONSUMO_ARREDONDADO_ZERO: 'Consumo de tinta muito pequeno: arredondado para zero.',
  OP_SEM_QUANTIDADE: 'Consumo previsto a definir: a OP não tem quantidade (entrada do lote zerada ou saldo devolvido igual à entrada).',
};

export const TEXTO_AVISOS_NAO_BLOQUEIAM = 'A liberação não é bloqueada por estes avisos.';

/** Códigos do servidor -> frases legíveis, sem repetição; código desconhecido aparece como veio (nunca é engolido). */
export function avisosLegiveis(codigos: readonly string[] | null | undefined): string[] {
  const frases: string[] = [];
  for (const codigo of codigos ?? []) {
    const frase = (ROTULO_AVISO_CONSUMO as Readonly<Record<string, string>>)[codigo] ?? codigo;
    if (!frases.includes(frase)) frases.push(frase);
  }
  return frases;
}
